import {
  FILTERS_PAGE_SIZE,
  useAutoSelectDefaultFilters,
  useFilterPanelState
} from '../../../../controls/AnalyticsFilters/AnalyticsFilterPanel.hooks'
import AnalyticsFilters from '../../../../controls/AnalyticsFilters/AnalyticsFilters'
import { SelectedFilter } from '../../../../data/model/results'
import { useProjectId } from '../../../../hooks/useProjectId'
import { getSelectedFilterCount } from '../../../../utils/resultsUtils'
import { useCombinedAnalyticsFilters } from '../../Survey/Results/AnalyticsFilters.hooks'

interface Props {
  selectedFilters: SelectedFilter[]
  setSelectedFilters: (selectedFilters: SelectedFilter[]) => void
  language?: string
  languageLoading?: boolean
}

/**
 * Combined-view counterpart of AnalyticsResultsFilters: the same panel, keyed on
 * the project rather than a survey. In MMv2 every market shares one
 * questionnaire, so a fork's id is the same across markets and the combined
 * endpoint's fork filters render and apply exactly like the per-survey ones.
 */
export const CombinedAnalyticsResultsFilters = ({
  selectedFilters,
  setSelectedFilters,
  language,
  languageLoading
}: Props) => {
  const projectId = useProjectId()
  const {
    currentOffset,
    setCurrentOffset,
    searchQuery,
    setSearchQuery,
    debouncedSearchQuery
  } = useFilterPanelState(language, selectedFilters)

  const {
    loading: loadingFilters,
    totalCount,
    filters,
    forkFilters,
    knownFilters,
    knownForkFilters,
    error
  } = useCombinedAnalyticsFilters({
    projectId,
    search: debouncedSearchQuery,
    offset: currentOffset,
    limit: FILTERS_PAGE_SIZE,
    selectedFilters,
    language,
    languageLoading
  })

  useAutoSelectDefaultFilters(
    filters,
    forkFilters,
    selectedFilters,
    setSelectedFilters
  )

  if (error) {
    return <div>Error loading filters</div>
  }

  return (
    <AnalyticsFilters
      isLoading={loadingFilters}
      filterCount={getSelectedFilterCount(selectedFilters)}
      filters={filters}
      forkFilters={forkFilters}
      knownFilters={knownFilters}
      knownForkFilters={knownForkFilters}
      selectedFilters={selectedFilters}
      setSelectedFilters={setSelectedFilters}
      totalCount={totalCount}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      currentOffset={currentOffset}
      setCurrentOffset={setCurrentOffset}
      limit={FILTERS_PAGE_SIZE}
    />
  )
}
